import { ReactNode } from 'react'

import LinkButton from 'shared/ui/Button/LinkButton'
import FormattedText from 'shared/ui/FormattedText'

import OrderSteps from '../landings/Steps'

import {
  SectionCenterHeader,
  SectionWithPadding,
  StyledCustomPortableText
} from './styles'

import styles from './HowMakeOrderCycleSection.module.scss'

interface HowMakeOrderCycleSectionProps {
  header: string
  content: string | ReactNode
  steps: Array<string | ReactNode>
  cta: {
    text: string
    href: string
  }
}
export default function HowMakeOrderCycleSection({
  header,
  content,
  steps,
  cta
}: HowMakeOrderCycleSectionProps) {
  return (
    <SectionWithPadding
      className={styles.orderCycleSection}
      $sizeTop='large'
      $sizeBottom='medium'
      $tablet
      $mobile
      $condensed
    >
      <div className={styles.orderCycleContent}>
        <SectionCenterHeader className={styles.header}>
          <FormattedText text={header} />
        </SectionCenterHeader>
        <StyledCustomPortableText>{content}</StyledCustomPortableText>
        <OrderSteps className={styles.orderCycleSteps} steps={steps} />
        <LinkButton href={cta.href} variant='primary' size='large'>
          {cta.text}
        </LinkButton>
      </div>
    </SectionWithPadding>
  )
}
